import React from 'react';
import { motion } from 'framer-motion';
import { LogIn, ShieldCheck, Sparkles } from 'lucide-react';
import { Background } from '../components/game/Background';
import { Mascot } from '../components/game/Mascot';
import { goToGoogleLogin } from '../lib/api';

export default function LoginScreen() {
  return (
    <Background>
      <div className="mx-auto flex min-h-[100dvh] max-w-md flex-col items-center justify-center px-5 py-8">
        <motion.div
          initial={{ scale: 0.6, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ type: 'spring', stiffness: 120, damping: 12 }}
        >
          <Mascot mood="happy" size={150} />
        </motion.div>

        <motion.h1
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.15 }}
          className="mt-2 text-center font-fred text-4xl font-bold leading-tight text-indigo-900 drop-shadow sm:text-5xl"
        >
          Tabuada <span className="text-pink-500">Divertida</span>
        </motion.h1>
        <p className="mt-2 mb-6 text-center text-lg font-bold text-purple-700">
          Aprender pode ser divertido! <Sparkles className="mb-1 inline h-5 w-5 text-amber-400" />
        </p>

        <motion.div
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="card-soft w-full p-6 text-center"
        >
          <p className="mb-5 font-fred text-lg font-semibold text-slate-700">
            Entre com a sua conta Google para começar
          </p>
          <button
            data-testid="google-login-btn"
            onClick={goToGoogleLogin}
            className="btn-3d w-full bg-white px-6 py-4 text-lg text-slate-700"
            style={{ borderColor: '#e2e8f0' }}
          >
            <svg className="h-6 w-6" viewBox="0 0 48 48" aria-hidden>
              <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9.1 3.6l6.8-6.8C35.9 2.4 30.4 0 24 0 14.6 0 6.4 5.4 2.6 13.2l7.9 6.1C12.3 13.2 17.7 9.5 24 9.5z" />
              <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.5 3-2.2 5.5-4.7 7.2l7.3 5.7c4.3-3.9 6.7-9.7 6.7-17.4z" />
              <path fill="#FBBC05" d="M10.5 28.3c-.5-1.4-.8-2.9-.8-4.3s.3-3 .8-4.3l-7.9-6.1C.9 16.8 0 20.3 0 24s.9 7.2 2.6 10.4l7.9-6.1z" />
              <path fill="#34A853" d="M24 48c6.4 0 11.9-2.1 15.9-5.8l-7.3-5.7c-2 1.4-4.7 2.3-8.6 2.3-6.3 0-11.7-3.7-13.5-9.1l-7.9 6.1C6.4 42.6 14.6 48 24 48z" />
            </svg>
            Entrar com Google
          </button>
          <p className="mt-4 flex items-center justify-center gap-2 text-xs font-bold text-slate-400">
            <ShieldCheck className="h-4 w-4 text-emerald-400" />
            Seus dados ficam protegidos
          </p>
        </motion.div>
      </div>
    </Background>
  );
}
